import gql from 'graphql-tag';

export const getProfileVisibility = gql`
  query GetProfileVisibility($languageCode: LanguageCodeIso) {
    viewer {
      _id
      id
      profileVisibility(languageCode: $languageCode) {
        level
        description
      }
    }
  }
`;

export const updateProfileVisibilityMutation = gql`
  mutation UpdateProfileVisibility(
    $input: UpdateProfileVisibilityInput!
    $languageCode: LanguageCodeIso
    $locale: Locale!
  ) {
    updateProfileVisibility(input: $input) {
      viewer {
        _id
        id

        profileVisibility(languageCode: $languageCode) {
          level
          description
        }

        profileVisibility2 {
          __typename
          id
          label: name(locale: $locale)
        }
      }
    }
  }
`;
